import styled from 'styled-components';

type AppVersionProps = {
  showSha?: boolean;
  collapsed?: boolean;
};

const VersionText = styled.span<{ $collapsed: boolean }>`
  display: ${({ $collapsed }) => ($collapsed ? 'none' : 'block')};
  font-size: ${({ theme }) => theme.typography.sizes.xs}px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.4);
  text-align: center;
  padding: 4px 0 8px;
  user-select: none;
  letter-spacing: 0.3px;
  white-space: nowrap;
`;

const AppVersion = ({ showSha = false, collapsed = false }: AppVersionProps) => {
  const version = `v${__APP_VERSION__}`;
  const sha = __APP_BUILD_SHA__;
  const label = showSha && sha ? `${version} (${sha.slice(0, 7)})` : version;

  return <VersionText $collapsed={collapsed}>{label}</VersionText>;
};

export default AppVersion;
